import {
  DeletedOrderType,
  OrderDeletedFailureAction,
  OrderDeletedRequestAction,
  OrderDeletedStatusResest,
  OrderDeletedSuccessAction,
  SalaryCardActions,
  SalaryCardActionTypes,
} from 'store/types/salaryCard'

import { Dispatch } from 'react'

import { getDeletedOrder } from '../../../services/SalaryCards/removeOrder'
import { setGlobalErrorAction } from '../globalError'

export const fetchOrderDeletedRequest = (): OrderDeletedRequestAction => ({
  type: SalaryCardActionTypes.FETCH_DELETED_ORDER_REQUEST,
})

export const fetchOrderDeletedSuccess = (
  data: DeletedOrderType
): OrderDeletedSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_DELETED_ORDER_SUCCESS,
  payload: data,
})

export const fetchOrderDeletedFailure = (error): OrderDeletedFailureAction => ({
  type: SalaryCardActionTypes.FETCH_DELETED_ORDER_FAILURE,
  payload: error,
})
export const fetchOrderDeletedStatusReset = (): OrderDeletedStatusResest => ({
  type: SalaryCardActionTypes.RESET_DELETED_ORDER_STATUS,
  
})
export const fetchDeletedOrder = (requestData: {
  orderNo: string
  description: string
}) => {
  const { orderNo } = requestData
  return async (dispatch: Dispatch<SalaryCardActions>) => {
    dispatch(fetchOrderDeletedRequest())

    try {
      const data = await getDeletedOrder(requestData)

      dispatch(fetchOrderDeletedSuccess({ id: orderNo }))
    } catch (error) {
      dispatch(fetchOrderDeletedFailure(error.message))
      dispatch(setGlobalErrorAction(error.message ?? ''));
    }
  }
}
